
export const strongTranslationsJA = {
  "G11": {
    m: "アブラハム",
    d: "族長アブラハム、信仰者の父です。",
    u: "新約聖書で73回使用されています。信仰の模範です。",
    e: "ヘブライ語אַבְרָהָם（アブラハム）から = 多くの者の父"
  },
  "G25": {
    m: "神聖で無条件の愛で愛する",
    d: "無私で犠牲的で神聖な愛で愛すること。これは神が人類に対して持つ愛であり、クリスチャンが互いに愛し合うべき愛です。人間的な愛とは異なり、これは意志の選択であり、感情ではありません。",
    u: "新約聖書で143回使用されています。神聖で完全で無条件の愛を表します。",
    e: "ἄγω（アゴー）から = 導く、善へと向かわせる"
  },
  "G26": {
    m: "神の愛、慈愛",
    d: "神の完全な愛。兄弟愛、情愛、善意、慈善。神と人、そして人と隣人を結ぶ愛です。",
    u: "新約聖書で116回使用されています。キリスト教における神の愛を表す中心的な言葉です。",
    e: "ἀγαπάω（アガパオー）に由来"
  },
  "G27": {
    m: "愛される、親愛なる",
    d: "愛された、大切にされた。神または人に愛されたものです。",
    u: "新約聖書で61回使用されています。神の愛する子です。",
    e: "ἀγαπάω（アガパオー）から = 愛する"
  },
  "G32": {
    m: "天使、使者",
    d: "使者。神に仕える天の使いです。",
    u: "新約聖書で175回使用されています。神の天使です。",
    e: "ἀγγέλλω（アンゲロー）から = 告げる"
  },
  "G36": {
    m: "卑しい身分の、身分の低い",
    d: "高貴さのない、卑しい出自。軽蔑されたものです。",
    u: "新約聖書で1回使用されています（1コリント1:28）。",
    e: "ἀ-（否定）+ γένος（ゲノス）= 出生"
  },
  "G93": {
    m: "不正、不義",
    d: "権利の侵害、不正。邪悪さ、道徳的不義です。",
    u: "新約聖書で25回使用されています。δικαιοσύνη（義）の反対です。",
    e: "ἀ-（否定）+ δίκη（ディケー）= 正義"
  },
  "G154": {
    m: "求める、願う、頼む",
    d: "求める、何かを願う、頼む、請願する。謙虚で敬意ある要求。",
    u: "新約聖書で70回使用されています。神や人に向けられた要求。",
    e: "αἰτέω（アイテオー）基本語根から；求める"
  },
  "G166": {
    m: "永遠の、永久の",
    d: "始まりも終わりもなく、常に存在するもの。新約聖書では、神における永遠の命と結びつきます。",
    u: "新約聖書で71回使用されています。しばしば永遠の命と神の国を修飾します。",
    e: "αἰών（アイオーン）から = 時代、世、永遠"
  },
  "G225": {
    m: "真理、真実",
    d: "神と人の義務に関する事柄において真実であること。啓示された神の真理です。",
    u: "新約聖書で109回使用されています。イエスの教えの中心概念です。",
    e: "ἀληθής（アレーセース）から = 真実な、誠実な"
  },
  "G281": {
    m: "アーメン、まことに",
    d: "確認の公式。そのようになりますように、まことに、確かにです。",
    u: "新約聖書で129回使用されています。イエスは「まことに、まことに」と言われます。",
    e: "ヘブライ語אָמֵן（アーメン）から = 堅固な、忠実な"
  },
  "G444": {
    m: "人、人間",
    d: "人間、男性または女性。全体としての人類です。",
    u: "新約聖書で550回使用されています。神のかたちに造られた人です。",
    e: "ἀνήρ（アネール）= 男性 + ὤψ（オープス）= 顔"
  },
  "G622": {
    m: "失う、滅ぼす、滅びる",
    d: "完全に破壊する。失う、滅びる。滅ぼされることです。",
    u: "新約聖書で90回使用されています。失われたものを救うです。",
    e: "ἀπό（アポ）= から + ὄλλυμι（オルミ）= 破壊する"
  },
  "G649": {
    m: "遣わす、派遣する",
    d: "使命を持って遣わす。大使として派遣することです。",
    u: "新約聖書で132回使用されています。父は子を遣わされます。",
    e: "ἀπό（アポ）= から + στέλλω（ステロー）= 遣わす"
  },
  "G721": {
    m: "小羊",
    d: "小さな子羊。神の小羊であるイエス・キリストを指します。",
    u: "新約聖書で30回使用されています、主に黙示録で。",
    e: "ἀρήν（アレーン）= 子羊 の縮小形"
  },
  "G730": {
    m: "男性、男",
    d: "男性の性、男です。",
    u: "新約聖書で9回使用されています。神は人を男と女に造られました。",
    e: "基本語根"
  },
  "G740": {
    m: "パン",
    d: "パン、食物。命のパン = キリストです。",
    u: "新約聖書で97回使用されています。イエスは命のパンです。",
    e: "ἄρω（アロー）から = 持ち上げる、上げる"
  },
  "G746": {
    m: "始まり、起源",
    d: "始まり、起源、第一原理。ヨハネ1:1-2では、言葉（ロゴス）がすでに存在していた永遠の始まりを指します。",
    u: "新約聖書で55回使用されています。ヨハネ1:1の重要な言葉「初めに言があった」。",
    e: "第一次的な言葉；始まり、最初の起源"
  },
  "G772": {
    m: "弱い、病気の",
    d: "力のない、弱い。病気の、虚弱な。霊的に弱いです。",
    u: "新約聖書で25回使用されています。神は世の弱いものを選ばれます。",
    e: "ἀ-（否定）+ σθένος（ステノス）= 力"
  },
  "G907": {
    m: "バプテスマを授ける、浸す",
    d: "水に浸す。清めまたは入信のためにバプテスマを授けることです。",
    u: "新約聖書で77回使用されています。キリスト教のバプテスマです。",
    e: "βάπτω（バプトー）から = 浸す、沈める"
  },
  "G1080": {
    m: "生む、生まれさせる",
    d: "生む、誕生させる。霊的に新しく生まれることです。",
    u: "新約聖書で97回使用されています。神から生まれる、新しく生まれるです。",
    e: "基本語根"
  },
  "G1096": {
    m: "なる、起こる、生じる",
    d: "なる、存在に至る、起こる、発生する、生じる。",
    u: "新約聖書で678回使用されています。「すべてのものは、これによって造られた」（ヨハネ1:3）。",
    e: "γίνομαι（ギノマイ）から = なる"
  },
  "G1097": {
    m: "知る、理解する",
    d: "個人的な経験によって知ること。理解し、知覚し、意識することです。",
    u: "新約聖書で222回使用されています。知的なだけでなく経験的な知識です。",
    e: "インド・ヨーロッパ語根*gen- = 生む、知る"
  },
  "G1100": {
    m: "舌、言語",
    d: "話す器官。言語、方言。異言の賜物です。",
    u: "新約聖書で50回使用されています。異言の賜物です。",
    e: "基本語根"
  },
  "G1166": {
    m: "示す、証明する",
    d: "目に見せる、示す。証明する、論証することです。",
    u: "新約聖書で33回使用されています。神はその栄光を示されます。",
    e: "基本語根"
  },
  "G1208": {
    m: "第二の、二番目の",
    d: "系列または順序における第二です。",
    u: "新約聖書で44回使用されています。第二の戒めです。",
    e: "δύο（デュオ）から = 二"
  },
  "G1271": {
    m: "知性、思考",
    d: "考え、聞き、理解する能力。心、理解力です。",
    u: "新約聖書で12回使用されています。キリストによって新しくされた心です。",
    e: "διά（ディア）= 通して + νοῦς（ヌース）= 心"
  },
  "G1320": {
    m: "教師、師、指導者",
    d: "教師、指導者；宗教的真理を教える者。",
    u: "新約聖書で59回使用されています。「ラビ、私たちは、あなたが神のもとから来られた教師であることを知っています」（ヨハネ3:2）。",
    e: "διδάσκω（ディダスコー）から = 教える"
  },
  "G1325": {
    m: "与える、授ける",
    d: "誰かに何かを与えること。授ける、許す。引き渡すことです。",
    u: "新約聖書で415回使用されています。神は惜しみなく与えられます。",
    e: "基本語根"
  },
  "G1372": {
    m: "渇く、切望する",
    d: "喉の渇きに苦しむ。切望する、熱望することです。",
    u: "新約聖書で16回使用されています。神への霊的な渇きです。",
    e: "δίψα（ディプサ）から = 渇き"
  },
  "G1401": {
    m: "奴隷、しもべ",
    d: "奴隷、しもべ。自発的な神のしもべです。",
    u: "新約聖書で124回使用されています。キリストのしもべです。",
    e: "δέω（デオー）から = 縛る"
  },
  "G1411": {
    m: "力、能力、奇跡",
    d: "力、権能、能力。力ある業、奇跡です。",
    u: "新約聖書で120回使用されています。神の力、聖霊の力です。",
    e: "δύναμαι（デュナマイ）から = できる"
  },
  "G1417": {
    m: "二",
    d: "数字の二。一対です。",
    u: "新約聖書で135回使用されています。二人または三人の証人です。",
    e: "基本語根"
  },
  "G1473": {
    m: "私",
    d: "一人称単数の人称代名詞です。",
    u: "新約聖書で2567回使用されています。非常に頻繁です。",
    e: "基本代名詞"
  },
  "G1484": {
    m: "国民、民族、異邦人",
    d: "民族、国家。異邦の国々（非ユダヤ人）です。",
    u: "新約聖書で162回使用されています。すべての国民への福音です。",
    e: "基本語根"
  },
  "G1492": {
    m: "知る、見る、理解する",
    d: "知覚によって知る、見る、理解する、気づく。経験や啓示によって得られた知識。",
    u: "新約聖書で666回使用されています。ヨハネの福音書における知識の基本動詞。",
    e: "εἴδω（エイドー）の完了形；見る、知る"
  },
  "G1510": {
    m: "である、存在する",
    d: "すべての意味での動詞「である」。存在する、とどまる、起こることです。",
    u: "新約聖書で最も使用される動詞（2460回以上）です。",
    e: "基本語根"
  },
  "G1515": {
    m: "平和",
    d: "平穏の状態。神との平和。人々の間の調和です。",
    u: "新約聖書で92回使用されています。キリストの平和です。",
    e: "εἴρω（エイロー）から = 結ぶ、つなぐ"
  },
  "G1520": {
    m: "一つ、唯一の",
    d: "一つだけ。唯一の、ただ一つの。あるものです。",
    u: "新約聖書で344回使用されています。神の一致、教会の一致です。",
    e: "基本語根"
  },
  "G1586": {
    m: "選ぶ、選び出す",
    d: "自分のために選ぶ、選択する。神の恵みによって選ばれることです。",
    u: "新約聖書で21回使用されています。神はその子らを選ばれます。",
    e: "ἐκ（エク）= から + λέγω（レゴー）= 選ぶ"
  },
  "G1658": {
    m: "自由な、解放された",
    d: "自由な、奴隷でない。罪の奴隷から解放されたものです。",
    u: "新約聖書で23回使用されています。キリストにあって自由です。",
    e: "おそらくἔρχομαι（エルコマイ）= 来る から"
  },
  "G1672": {
    m: "ギリシャ人、異邦人",
    d: "生まれまたは言語においてギリシャ人。非ユダヤ人です。",
    u: "新約聖書で25回使用されています。キリストにあってユダヤ人もギリシャ人もありません。",
    e: "Ἑλλάς（ヘラス）から = ギリシャ"
  },
  "G1680": {
    m: "希望、確信のある期待",
    d: "良いことへの期待、神に基づく希望。神の約束に基づく将来への信頼です。",
    u: "新約聖書で54回使用されています。信仰と愛と並ぶ三つの神学的美徳の一つです。",
    e: "ἔλπω（エルポー）から = 待つ、望む"
  },
  "G1743": {
    m: "強める、強くする",
    d: "強くする、力づける。力を与えることです。",
    u: "新約聖書で8回使用されています。神は信者を強められます。",
    e: "ἐν（エン）= 中に + δυναμόω（デュナモオー）= 力を与える"
  },
  "G1746": {
    m: "着る、身につける",
    d: "衣服を着る。性質または力を身につけることです。",
    u: "新約聖書で27回使用されています。キリストを着る、神の武具を着るです。",
    e: "ἐν（エン）= 中に + δύω（デュオー）= 入る、着る"
  },
  "G1785": {
    m: "戒め、命令",
    d: "命令、戒め、訓令。特に神の命令です。",
    u: "新約聖書で67回使用されています。神とキリストの戒めです。",
    e: "ἐντέλλομαι（エンテロマイ）から = 命じる"
  },
  "G1848": {
    m: "軽蔑する、見下す",
    d: "無とみなす、軽蔑する。軽蔑的に扱うことです。",
    u: "新約聖書で11回使用されています。世は神が選ばれるものを軽蔑します。",
    e: "ἐξ（エクス）= から + οὐθείς（ウーセイス）= 誰も～ない"
  },
  "G2041": {
    m: "仕事、働き、行為",
    d: "仕事、労働。行動、行為。成し遂げられた業です。",
    u: "新約聖書で169回使用されています。神の業、良い行いです。",
    e: "ἔργω（エルゴー）から = 働く"
  },
  "G2048": {
    m: "荒野、荒れた",
    d: "荒れた場所、荒野。孤独な、無人のです。",
    u: "新約聖書で48回使用されています。イエスの荒野での40日間です。",
    e: "ἔρημος（エレーモス）から = 見捨てられた"
  },
  "G2065": {
    m: "尋ねる、質問する、問う",
    d: "尋ねる、質問する、情報を求めて問う。調査や調べ。",
    u: "新約聖書で63回使用されています。答えを得るための質問。",
    e: "不確実な語根；尋ねる、質問する"
  },
  "G2189": {
    m: "敵意、対立",
    d: "憎しみ、敵意、敵対です。",
    u: "新約聖書で6回使用されています。神との敵意は廃止されました。",
    e: "ἐχθρός（エクスロス）から = 敵"
  },
  "G2205": {
    m: "熱心、嫉妬、羨望",
    d: "情熱的な熱意。神への熱心として肯定的にも、嫉妬や羨望として否定的にもなり得ます。",
    u: "新約聖書で16回使用されています。文脈により美徳にも悪徳にもなります。",
    e: "ζέω（ゼオー）から = 沸騰する、熱烈である"
  },
  "G2222": {
    m: "命",
    d: "肉体的または霊的な命。神における永遠の命です。",
    u: "新約聖書で135回使用されています。イエスは命です。",
    e: "ζάω（ザオー）から = 生きる"
  },
  "G2258": {
    m: "だった、彼はだった",
    d: "だった、彼はだった、彼女はだった。動詞である（εἰμί）の未完了形。過去の状態や存在を表す。",
    u: "新約聖書で267回使用されています。ヨハネ1:1「初めに言葉があった」で重要。",
    e: "εἰμί（エイミ）の未完了形 = である；だった"
  },
  "G2296": {
    m: "驚く、驚嘆する、感嘆する",
    d: "驚く、驚嘆する、驚かされる、感嘆する。並外れたものに対する驚きの反応。",
    u: "新約聖書で43回使用されています。イエスの奇跡と教えに対する頻繁な反応。",
    e: "θαῦμα（タウマ）= 驚異から；驚く"
  },
  "G2316": {
    m: "神、神性",
    d: "唯一の真の神、最高で永遠の存在。新約聖書では父なる神、またはイエス・キリストの子、または聖霊を指します - 聖三位一体。",
    u: "新約聖書で1343回使用されています。三位一体の統一における唯一の真の神を指す基本的な言葉です。",
    e: "ストロングによれば語源不詳。神格、特に最高の神性を指す。聖書的用法：救済史において働く生ける神を啓示する。"
  },
  "G2338": {
    m: "女性、女",
    d: "女性の性、女です。",
    u: "新約聖書で5回使用されています。男と女はキリストにあって平等です。",
    e: "θηλάζω（セーラゾー）から = 授乳する"
  },
  "G2362": {
    m: "王座",
    d: "王の座、王座。王権と権威です。",
    u: "新約聖書で62回使用されています。神と小羊の王座です。",
    e: "基本語根"
  },
  "G2381": {
    m: "トマス",
    d: "トマス、固有名詞。十二使徒の一人、ディディモ（双子）とも呼ばれる。復活の証拠を求めたことで知られる。",
    u: "新約聖書で11回使用されています。疑い、そして信じた使徒。",
    e: "アラム語תְּאוֹמָא（テオマ）から = 双子"
  },
  "G2398": {
    m: "自分の、特別な、個人的な",
    d: "自分の、特別な、個人的な、私的な。誰かに特に属するもの、他と区別される。",
    u: "新約聖書で114回使用されています。個人的所有と区別の概念。",
    e: "不確実な語根から；自分の、特別な"
  },
  "G2424": {
    m: "イエス",
    d: "ナザレのイエス、メシア、救い主です。",
    u: "新約聖書で917回使用されています。すべての名にまさる名です。",
    e: "ヘブライ語יְהוֹשֻׁעַ（イェホシュア）から = 主は救う"
  },
  "G2453": {
    m: "ユダヤ人、ユダヤの",
    d: "ユダヤ民族に属する。ユダヤの住民です。",
    u: "新約聖書で195回使用されています。ユダヤ人、神に選ばれた民です。",
    e: "Ἰούδας（イウダス）から = ユダ"
  },
  "G2491": {
    m: "ヨハネ",
    d: "ヨハネ、固有名詞。先駆者である洗礼者ヨハネ、愛弟子ヨハネ、福音書と手紙の著者。",
    u: "新約聖書で135回使用されています。新約聖書の二大人物の名前。",
    e: "ヘブライ語יוֹחָנָן（ヨハナン）から = YHWHは恵み深い"
  },
  "G2531": {
    m: "～のように、～に従って",
    d: "～のように、同じように。～に従って、～に応じてです。",
    u: "新約聖書で182回使用されています。比較の接続詞です。",
    e: "κατά（カタ）= ～に従って + ὡς（ホース）= ～のように"
  },
  "G2537": {
    m: "新しい、最近の",
    d: "時間または質において新しい。新鮮な、最近の、使われていないものです。",
    u: "新約聖書で42回使用されています。新しい創造、新しい戒めです。",
    e: "語根不明"
  },
  "G2570": {
    m: "良い、美しい",
    d: "本質において良い、美しい。立派な、優れた、徳のあるものです。",
    u: "新約聖書で100回使用されています。良い羊飼い、良い行いです。",
    e: "基本語根"
  },
  "G2588": {
    m: "心",
    d: "肉体的な心臓。内的生活の中心、魂、精神。思考と感情です。",
    u: "新約聖書で156回使用されています。霊的生活の座です。",
    e: "基本語根"
  },
  "G2596": {
    m: "～に従って、～に反対して、～を通して",
    d: "複数の意味を持つ前置詞。～に従って、～に一致して。～に反対して。～を通してです。",
    u: "新約聖書で470回以上使用されています。非常に頻繁に使われる前置詞です。",
    e: "基本前置詞"
  },
  "G2617": {
    m: "恥じ入らせる、辱める",
    d: "恥じ入らせる、不名誉にする。困惑させる、謙虚にすることです。",
    u: "新約聖書で13回使用されています。神は世の賢い者を辱められます。",
    e: "κατά（カタ）= に対して + αἰσχύνω（アイスキュノー）= 恥じる"
  },
  "G2744": {
    m: "誇る、自慢する",
    d: "誇る、自慢する。何かに誇りを見出すことです。",
    u: "新約聖書で37回使用されています。主にあって誇るです。",
    e: "καῦχος（カウコス）から = 自慢"
  },
  "G2889": {
    m: "世界、宇宙、人類",
    d: "世界の秩序、宇宙。堕落した人類。神に敵対するシステムです。",
    u: "新約聖書で186回使用されています。創造物または罪深いシステムを指します。",
    e: "κοσμέω（コスメオー）から = 飾る、整える"
  },
  "G2919": {
    m: "裁く、決定する",
    d: "裁く、裁きを宣告する。決定する、定めることです。",
    u: "新約聖書で114回使用されています。神は世を裁かれます。",
    e: "基本語根"
  },
  "G2920": {
    m: "裁き、正義、裁判",
    d: "裁き、正義、裁判、司法的決定。神の裁き、正しく完全。",
    u: "新約聖書で47回使用されています。神の正義の中心概念。",
    e: "κρίνω（クリノー）から = 裁く、決める"
  },
  "G2962": {
    m: "主、主人、所有者",
    d: "主、主人；尊敬と神の権威の称号；イエスが主として。",
    u: "新約聖書で748回使用されています。「トマスはイエスに言った。『主よ、どこへ行かれるのか、私たちには分かりません』」（ヨハネ14:5）。",
    e: "κύριος（キュリオス）から = 権威を持つ"
  },
  "G2992": {
    m: "民",
    d: "民、国家。特に神の民（イスラエルまたは教会）です。",
    u: "新約聖書で142回使用されています。神に選ばれた民です。",
    e: "基本語根"
  },
  "G3022": {
    m: "白い、輝く",
    d: "白い、輝く。純潔と勝利の象徴です。",
    u: "新約聖書で25回使用されています。贖われた者の白い衣です。",
    e: "λευκός（レウコス）から = 白い、明るい"
  },
  "G3056": {
    m: "言葉、ことば、理性",
    d: "語られた言葉。理性、知性。ロゴス = キリストです。",
    u: "新約聖書で330回使用されています。受肉したロゴスです。",
    e: "λέγω（レゴー）から = 言う"
  },
  "G3101": {
    m: "弟子、学生",
    d: "学習者、学生、弟子。イエスの従者です。",
    u: "新約聖書で261回使用されています。キリストの従者を指します。",
    e: "μανθάνω（マンサノー）から = 学ぶ"
  },
  "G3141": {
    m: "証し、証言",
    d: "証し、証言、証拠、立証。真理への証し、特にキリストへの証し。",
    u: "新約聖書で37回使用されています。ヨハネの福音書の主要テーマ。",
    e: "μάρτυς（マルトゥス）から = 証人"
  },
  "G3173": {
    m: "大きい、重要な",
    d: "大きさ、量、または重要性において大きい。力強い、素晴らしいです。",
    u: "新約聖書で243回使用されています。神の偉大さです。",
    e: "基本語根"
  },
  "G3320": {
    m: "隔ての壁",
    d: "中間の壁、分離の仕切りです。",
    u: "新約聖書で1回使用されています（エペソ2:14）。ユダヤ人と異邦人の間の壁です。",
    e: "μέσος（メソス）= 真ん中 + τοῖχος（トイコス）= 壁"
  },
  "G3439": {
    m: "唯一の、独り子の",
    d: "その種において唯一の、独り子。唯一の子です。",
    u: "新約聖書で9回使用されています。神の独り子です。",
    e: "μόνος（モノス）= 唯一 + γίνομαι（ギノマイ）= なる"
  },
  "G3474": {
    m: "愚かさ、愚行",
    d: "愚かさ、不条理。知恵に欠けるものです。",
    u: "新約聖書で5回使用されています。神の知恵は世に愚かに見えます。",
    e: "μωρός（モーロス）から = 愚かな、無知な"
  },
  "G3475": {
    m: "モーセ",
    d: "モーセ、イスラエルの律法授与者です。",
    u: "新約聖書で80回使用されています。モーセの律法です。",
    e: "ヘブライ語מֹשֶׁה（モーシェ）から = 引き出された（水から）"
  },
  "G3530": {
    m: "ニコデモ",
    d: "ニコデモ、固有名詞。夜にイエスのもとに来たパリサイ人でユダヤ人の指導者。「民の勝利」を意味するギリシャ語の名前。",
    u: "新約聖書で5回使用されています。ヨハネの福音書の重要な人物。",
    e: "ギリシャ語νίκη（ニケ）= 勝利、δῆμος（デモス）= 民から"
  },
  "G3551": {
    m: "律法、トーラー",
    d: "律法、トーラー、規則、原理。モーセの律法、神の律法、神の戒め。",
    u: "新約聖書で194回使用されています。神の啓示の中心概念。",
    e: "νέμω（ネモー）から = 配る、与える；与えられた律法"
  },
  "G3571": {
    m: "夜",
    d: "夜、日没と日の出の間の暗闇の期間。しばしば霊的無知の比喩。",
    u: "新約聖書で61回使用されています。ヨハネの象徴体系で光と対比される。",
    e: "基本的な女性名詞；夜"
  },
  "G3598": {
    m: "道、方法",
    d: "道路、道。生き方、行動。救いの道です。",
    u: "新約聖書で101回使用されています。イエスは道です。",
    e: "基本語根"
  },
  "G3609": {
    m: "家庭の、家の",
    d: "家に属する、家族の一員。家庭の召使いです。",
    u: "新約聖書で3回使用されています。神の家族のメンバーを表します。",
    e: "οἶκος（オイコス）から = 家"
  },
  "G3664": {
    m: "似ている、同じような",
    d: "似ている、同じ性質または特徴を持つ。等しいです。",
    u: "新約聖書で45回使用されています。第二の戒めは第一のものと似ています。",
    e: "ὁμός（ホモス）から = 同じ"
  },
  "G3686": {
    m: "名",
    d: "名、称号。評判。権威、力です。",
    u: "新約聖書で228回使用されています。イエスの名です。",
    e: "基本語根"
  },
  "G3708": {
    m: "見る、注視する",
    d: "目で見ること。知覚する、理解する。現れることです。",
    u: "新約聖書で454回使用されています。キリストを見る、父を見るです。",
    e: "基本語根"
  },
  "G3735": {
    m: "山、丘",
    d: "山、高い山。高い丘です。",
    u: "新約聖書で63回使用されています。変貌の山です。",
    e: "おそらくὁράω（ホラオー）= 見る から"
  },
  "G3756": {
    m: "いいえ、ない",
    d: "絶対的な否定、いいえ、ないです。",
    u: "新約聖書で1600回以上使用されています。非常に頻繁な否定詞です。",
    e: "基本否定詞"
  },
  "G3762": {
    m: "誰も、何も、誰一人",
    d: "誰も、何も、誰一人、一人も。存在や数量の絶対的否定。",
    u: "新約聖書で234回使用されています。非常に一般的な強い否定。",
    e: "οὐδέ（ウーデ）とεἷς（ヘイス）から；一人さえも"
  },
  "G3778": {
    m: "この、これ、この人",
    d: "指示代名詞：この、これ、この人。近くにあるものや以前に言及されたものを指す。",
    u: "新約聖書で1388回使用されています。最も頻繁な指示代名詞。",
    e: "第一次指示代名詞"
  },
  "G3789": {
    m: "蛇",
    d: "蛇、爬虫類。古い蛇（サタン）です。",
    u: "新約聖書で14回使用されています。荒野の青銅の蛇です。",
    e: "基本語根"
  },
  "G3793": {
    m: "群衆、大勢",
    d: "人々の群れ、大勢。大衆です。",
    u: "新約聖書で175回使用されています。イエスに従った群衆です。",
    e: "ὄχος（オコス）から = 乗り物（運ぶもの）"
  },
  "G3880": {
    m: "受ける、取る、受け入れる",
    d: "受ける、取る、受け入れる、つかむ。提供または与えられたものを受け取る。",
    u: "新約聖書で59回使用されています。福音を受け入れる中心概念。",
    e: "παρά（パラ）= そばに、λαμβάνω（ランバノ）= 取るから"
  },
  "G3956": {
    m: "すべて、各々",
    d: "すべて、各々、みな。全体、総体です。",
    u: "新約聖書で1244回使用されています。最も頻繁な語の一つです。",
    e: "基本語根"
  },
  "G3962": {
    m: "父",
    d: "自然的または霊的な父。祖先。父なる神です。",
    u: "新約聖書で413回使用されています。しばしば神を指します。",
    e: "ラテン語'pater'に関連する基本語根"
  },
  "G4100": {
    m: "信じる、信仰を持つ",
    d: "信仰を持つ、信じる。信頼する、頼ることです。",
    u: "新約聖書で241回使用されています。イエスを信じて救われるです。",
    e: "πίστις（ピスティス）から = 信仰"
  },
  "G4102": {
    m: "信仰、信頼、忠実",
    d: "あらゆる真理への確信、信念。新約聖書では、人と神および神的な事柄との関係に関する確信を意味します。",
    u: "新約聖書で244回使用されています。キリスト教信仰の中心概念です。",
    e: "πείθω（ペイソー）から = 説得する、納得させる"
  },
  "G4138": {
    m: "満ちること、豊富、満たすもの",
    d: "満ちること、豊富、完全に満たすもの。全体性、神的完全性。",
    u: "新約聖書で17回使用されています。キリストにおける神的満ちることの神学的概念。",
    e: "πλήρης（プレレス）= 満ちたから；満ちること"
  },
  "G4139": {
    m: "隣人、隣り人",
    d: "近くにいる人、隣人。一般的な意味での隣人です。",
    u: "新約聖書で17回使用されています。「あなたの隣人を自分自身のように愛しなさい」。",
    e: "副詞が名詞化、πλησίος（プレーシオス）から = 近く"
  },
  "G4151": {
    m: "霊、息、風",
    d: "命の息、生命の原理。理性的な魂。聖霊です。",
    u: "新約聖書で385回使用されています。聖霊、人間の霊、または霊的存在を指します。",
    e: "πνέω（プネオー）から = 吹く、呼吸する"
  },
  "G4160": {
    m: "する、作る、行う",
    d: "する、作る、生産する、行動する、創造する。あらゆる種類の活動を包括する一般的な行動動詞。",
    u: "新約聖書で568回使用されています。基本的な行動動詞、神の業でよく使われる。",
    e: "第一次動詞；する、行う"
  },
  "G4166": {
    m: "羊飼い、牧者",
    d: "羊を守る者。霊的な守護者、教会の牧師です。",
    u: "新約聖書で18回使用されています。イエスは良い羊飼いです。",
    e: "ποίμνη（ポイムネー）から = 群れ"
  },
  "G4183": {
    m: "多くの、たくさんの、大きな",
    d: "多くの、たくさんの、量や数において大きな。群衆、大量。",
    u: "新約聖書で416回使用されています。非常に頻繁な量的形容詞。",
    e: "不確実な語根；多くの、たくさんの"
  },
  "G4198": {
    m: "行く、歩く、旅する",
    d: "行く、歩く、旅する、動く。ある場所から別の場所への移動、しばしば目的を持って。",
    u: "新約聖書で154回使用されています。福音書の物語における基本的な移動動詞。",
    e: "基本動詞；行く、歩く"
  },
  "G4238": {
    m: "する、実践する、成し遂げる",
    d: "する、実践する、成し遂げる、行動する。行動を実行する、しばしば反復や習慣の概念を伴って。",
    u: "新約聖書で39回使用されています。しばしば善悪の実践と関連。",
    e: "πράω（プラオ）の強化形；する、実践する"
  },
  "G4263": {
    m: "羊、羊の群れ",
    d: "羊または羊の群れ。比喩的にキリストの弟子たちです。",
    u: "新約聖書で39回使用されています。信者は羊飼いの羊です。",
    e: "おそらくπροβαίνω（プロバイノー）= 前進する に関連"
  },
  "G4413": {
    m: "第一の、主要な",
    d: "時間、場所、順序、または重要性において第一です。",
    u: "新約聖書で155回使用されています。第一の戒め、第一の場所です。",
    e: "πρό（プロ）= 前 の最上級"
  },
  "G4561": {
    m: "肉、体",
    d: "肉、肉体。人間の体。堕落した人間性です。",
    u: "新約聖書で147回使用されています。肉と霊の対比です。",
    e: "基本語根"
  },
  "G4592": {
    m: "しるし、奇跡、不思議",
    d: "しるし、奇跡、不思議；神の力を現す超自然的な現れ。",
    u: "新約聖書で77回使用されています。「あなたがなさるこのようなしるしは、だれも行うことができないからです」（ヨハネ3:2）。",
    e: "σημεῖον（セーメイオン）から = しるし、印"
  },
  "G4648": {
    m: "注意深く見る、目指す",
    d: "目を固定する、注意深く考える。目標を持つ、目的に向かうことです。",
    u: "新約聖書で6回使用されています。キリストに目を注ぐよう呼びかけます。",
    e: "σκοπός（スコポス）= 標的、目標 に関連"
  },
  "G4680": {
    m: "賢い、学識のある",
    d: "賢い、知的な、熟練した。教育を受けた、学んだものです。",
    u: "新約聖書で22回使用されています。真の知恵は神から来ます。",
    e: "基本語根"
  },
  "G4982": {
    m: "救う、救い出す",
    d: "危険や破滅から救う。罪から救い出すことです。",
    u: "新約聖書で106回使用されています。イエスは罪人を救われます。",
    e: "σῶς（ソース）から = 安全な"
  },
  "G5040": {
    m: "小さな子ども",
    d: "小さな子ども、幼児。弟子への愛情のこもった呼びかけです。",
    u: "新約聖書で8回使用されています。ヨハネは読者を「小さな子どもたち」と呼びます。",
    e: "τέκνον（テクノン）= 子ども の縮小形"
  },
  "G5087": {
    m: "置く、設置する、定める",
    d: "置く、配置する。定める、任命する。横たえる、置くことです。",
    u: "新約聖書で100回使用されています。羊のために命を捨てるです。",
    e: "基本語根"
  },
  "G5109": {
    m: "壁",
    d: "分離の壁、仕切りです。",
    u: "新約聖書で1回使用されています（使徒23:3）。",
    e: "基本語根"
  },
  "G5207": {
    m: "息子",
    d: "男性の子孫。弟子。グループのメンバー。神の子 = イエス・キリストです。",
    u: "新約聖書で377回使用されています。しばしばイエスを神の子として指します。",
    e: "起源不明、おそらくὕω（ヒュオー）= 雨を降らせる、生む に関連"
  },
  "G5281": {
    m: "忍耐、耐久、堅忍",
    d: "状況や圧力に屈しない性質。忍耐強い耐久力、不変性です。",
    u: "新約聖書で32回使用されています。本質的なキリスト教の美徳です。",
    e: "ὑπό（ヒュポ）= 下に + μένω（メノー）= とどまる"
  },
  "G5312": {
    m: "上げる、高く上げる",
    d: "高く上げる、持ち上げる。称揚する、称えることです。",
    u: "新約聖書で20回使用されています。人の子は上げられます。",
    e: "ὕψος（ヒュプソス）から = 高さ"
  },
  "G5376": {
    m: "ピリポ",
    d: "ピリポ、固有名詞。十二使徒の一人。ギリシャ語名で「馬を愛する者」の意味。",
    u: "新約聖書で36回使用されています。使徒と執事の名前。",
    e: "ギリシャ語φίλος（ピロス）= 友人とἵππος（ヒッポス）= 馬から"
  },
  "G5432": {
    m: "守る、保護する",
    d: "軍の守衛によって守る。保護する、保つことです。",
    u: "新約聖書で4回使用されています。神の平和が私たちの心を守ります。",
    e: "φρουρός（フルーロス）から = 守衛、歩哨"
  },
  "G5443": {
    m: "部族、民",
    d: "部族、氏族。共通の祖先から生まれた民です。",
    u: "新約聖書で31回使用されています。イスラエルの十二部族です。",
    e: "φύω（フュオー）から = 生産する、成長させる"
  },
  "G5457": {
    m: "光",
    d: "物理的または霊的な光。啓示された神の真理です。",
    u: "新約聖書で73回使用されています。イエスは世の光です。",
    e: "φάω（ファオー）から = 輝く"
  },
  "G5463": {
    m: "喜ぶ、喜びに満ちる",
    d: "喜ぶこと、幸せであること。挨拶として「喜べ」または「こんにちは」です。",
    u: "新約聖書で74回使用されています。キリストにあって喜ぶよう頻繁に命じられます。",
    e: "χάρις（カリス）= 恵み に関連"
  },
  "G5495": {
    m: "手",
    d: "手。力、権威。行動、業です。",
    u: "新約聖書で177回使用されています。神の手、イエスの手です。",
    e: "基本語根"
  },
  "G5544": {
    m: "善良さ、親切",
    d: "行動における善良さ、実践的な親切。他者に有益で役立つ性質です。",
    u: "新約聖書で10回使用されています。ガラテヤ5:22の御霊の実です。",
    e: "χρηστός（クレストス）から = 良い、有用な、親切な"
  },
  "G5547": {
    m: "キリスト、メシア、油注がれた者",
    d: "油注がれた者、メシア。約束された救い主としてのイエスの称号です。",
    u: "新約聖書で529回使用されています。イエスはキリストです。",
    e: "χρίω（クリオー）から = 油を注ぐ"
  },
  "G5590": {
    m: "魂、命",
    d: "命の息、生命力。命そのもの。不滅の魂です。",
    u: "新約聖書で105回使用されています。霊的で永遠の命です。",
    e: "ψύχω（プシュコー）から = 呼吸する、冷やす"
  },
  "H120": {
    m: "人、人類、アダム",
    d: "人、人間。人類。最初の人アダムです。",
    u: "旧約聖書で562回使用されています。神は人を創造されました。",
    e: "אָדֹם（アードム）= 赤い、またはאֲדָמָה（アダーマー）= 土地 から"
  },
  "H160": {
    m: "愛、愛情",
    d: "愛、愛情。愛の行為です。",
    u: "旧約聖書で40回使用されています。神のその民への愛です。",
    e: "אָהַב（アーハブ）から = 愛する"
  },
  "H216": {
    m: "光",
    d: "自然的または霊的な光。幸福、繁栄です。",
    u: "旧約聖書で120回使用されています。「光あれ！」",
    e: "אוֹר（オール）から = 輝く"
  },
  "H430": {
    m: "神、神々",
    d: "至高の神（エロヒム）。時には裁判官や異教の神々にも使用されます。",
    u: "旧約聖書で2606回使用されています。神の威厳を表す複数形の名です。",
    e: "אֱלוֹהַּ（エローア）= 神 の複数形"
  },
  "H559": {
    m: "言う、話す",
    d: "言う、話す、宣言する。命じる、考えることです。",
    u: "旧約聖書で5316回使用されています。最も頻繁な言葉の動詞です。",
    e: "基本語根"
  },
  "H776": {
    m: "地、国",
    d: "地、土地。国、地域。地上の世界です。",
    u: "旧約聖書で2504回使用されています。神が創造された地です。",
    e: "基本語根"
  },
  "H982": {
    m: "信頼する、信用する",
    d: "信頼する、信用する。安全であることです。",
    u: "旧約聖書で120回使用されています。主への信頼です。",
    e: "基本語根"
  },
  "H1004": {
    m: "家、住まい",
    d: "家、住居。家族、家庭。神殿です。",
    u: "旧約聖書で2055回使用されています。主の家です。",
    e: "בָּנָה（バーナー）から = 建てる"
  },
  "H1254": {
    m: "創造する",
    d: "無から創造する。形づくる、造る。神だけの活動です。",
    u: "旧約聖書で54回使用されています。神は天と地を創造されました。",
    e: "基本語根"
  },
  "H1516": {
    m: "谷、峡谷",
    d: "谷、峡谷、深い谷。平原です。",
    u: "旧約聖書で60回使用されています。死の陰の谷です。",
    e: "基本語根"
  },
  "H1878": {
    m: "肥やす、太らせる",
    d: "太らせる、肥やす。繁栄させることです。",
    u: "旧約聖書で11回使用されています。あなたは私の頭に油を注がれます。",
    e: "דֶּשֶׁן（デシェン）から = 脂肪、灰"
  },
  "H1980": {
    m: "歩く、行く",
    d: "歩く、行く、来る。生きる、行動することです。",
    u: "旧約聖書で1554回使用されています。非常に頻繁な動きの動詞です。",
    e: "基本語根"
  },
  "H2617": {
    m: "恵み、あわれみ、誠実",
    d: "善良さ、あわれみ。契約への忠実。変わらぬ愛です。",
    u: "旧約聖書で248回使用されています。主の恵みです。",
    e: "חָסַד（ハーサド）から = 善良である、あわれむ"
  },
  "H2637": {
    m: "欠ける、必要とする",
    d: "欠ける、必要とする。減少する、不足することです。",
    u: "旧約聖書で23回使用されています。私は乏しいことがありません（詩篇23:1）。",
    e: "基本語根"
  },
  "H2896": {
    m: "良い、善い",
    d: "良い、快い、優れた。親切な、正しいです。",
    u: "旧約聖書で559回使用されています。神は見て良しとされました。",
    e: "基本語根"
  },
  "H3068": {
    m: "ヤハウェ、主",
    d: "神の固有名、聖なる四文字の神名YHWHです。",
    u: "旧約聖書で6828回使用されています。最も聖なる名です。",
    e: "הָיָה（ハーヤー）から = ある、存在する"
  },
  "H3117": {
    m: "日",
    d: "昼（夜の反対）。24時間の期間。時代、時です。",
    u: "旧約聖書で2301回使用されています。主が造られた日です。",
    e: "יוֹם（ヨーム）から = 暑い"
  },
  "H3372": {
    m: "恐れる、畏れる、敬う",
    d: "恐れる、畏れる。神を敬う、尊敬することです。",
    u: "旧約聖書で335回使用されています。私は災いを恐れません。",
    e: "基本語根"
  },
  "H3563": {
    m: "杯、盃",
    d: "杯、盃。分け前、運命です。",
    u: "旧約聖書で31回使用されています。私の杯はあふれます。",
    e: "基本語根"
  },
  "H3820": {
    m: "心、精神",
    d: "心、感情の座。精神、知性、意志です。",
    u: "旧約聖書で598回使用されています。人の心です。",
    e: "基本語根"
  },
  "H3915": {
    m: "夜",
    d: "夜（昼の反対）。暗闇の時です。",
    u: "旧約聖書で234回使用されています。神は昼と夜を分けられました。",
    e: "基本語根"
  },
  "H3966": {
    m: "非常に、極めて",
    d: "非常に、極めて、大いに。力強く、速くです。",
    u: "旧約聖書で300回使用されています。非常に良かったです。",
    e: "מָאַד（マーアド）から = 多い"
  },
  "H4325": {
    m: "水、水域",
    d: "水、水域。雨。洪水、海です。",
    u: "旧約聖書で585回使用されています。創造の水です。",
    e: "מַיִם（マイム）= 水 の双数形"
  },
  "H4999": {
    m: "牧草地、住まい",
    d: "牧草地の場所、草原。住居、住まいです。",
    u: "旧約聖書で13回使用されています。緑の牧場にです。",
    e: "נָאָה（ナーアー）から = 美しい、ふさわしい"
  },
  "H5148": {
    m: "導く、案内する",
    d: "導く、案内する、指図する。安全に導くことです。",
    u: "旧約聖書で40回使用されています。私を導かれます（詩篇23:3）。",
    e: "基本語根"
  },
  "H5216": {
    m: "牧草地、耕地",
    d: "草原、牧草地。耕された地、畑です。",
    u: "旧約聖書で2回使用されています。緑の牧場です。",
    e: "נִיר（ニール）から = 耕す"
  },
  "H5315": {
    m: "魂、命、人",
    d: "魂、命、生き物。人、自己。欲望、食欲です。",
    u: "旧約聖書で753回使用されています。私の魂、私の命です。",
    e: "נָפַשׁ（ナーファシュ）から = 呼吸する"
  },
  "H5769": {
    m: "永遠、とこしえ",
    d: "無限の時間、永遠。とこしえ、永久です。",
    u: "旧約聖書で439回使用されています。神の永遠の愛です。",
    e: "עָלַם（アーラム）から = 隠す、隠される"
  },
  "H6186": {
    m: "整える、配置する",
    d: "順序よく整える、配置する。食卓を準備することです。",
    u: "旧約聖書で75回使用されています。あなたは私の前に食卓を整えてくださいます（詩篇23:5）。",
    e: "基本語根"
  },
  "H6213": {
    m: "する、成し遂げる",
    d: "する、作る、成し遂げる。行動する、働くことです。",
    u: "旧約聖書で2632回使用されています。非常に頻繁な動詞です。",
    e: "基本語根"
  },
  "H6664": {
    m: "義、正しさ",
    d: "義、正しさ、公正。誠実です。",
    u: "旧約聖書で119回使用されています。義の道です。",
    e: "צָדַק（ツァーダク）から = 正しい"
  },
  "H6754": {
    m: "像、似姿",
    d: "像、似姿。形、外観です。",
    u: "旧約聖書で17回使用されています。人は神の像に造られました。",
    e: "צָלַל（ツァーラル）から = 影を作る、似る"
  },
  "H6757": {
    m: "死の陰、深い闇",
    d: "深い闇、死の闇。死の影です。",
    u: "旧約聖書で18回使用されています。極度の危険を象徴します。",
    e: "צֵל（ツェール）= 影 + מָוֶת（マーヴェト）= 死"
  },
  "H6887": {
    m: "苦しむ、敵対者",
    d: "締め付けられる、苦しむ。敵対者、敵です。",
    u: "旧約聖書で58回使用されています。私の敵の前でです。",
    e: "基本語根"
  },
  "H7121": {
    m: "呼ぶ、叫ぶ、宣言する",
    d: "呼ぶ、叫ぶ。名づける。宣言する、召集することです。",
    u: "旧約聖書で736回使用されています。主の名を呼ぶです。",
    e: "基本語根"
  },
  "H7200": {
    m: "見る、注視する",
    d: "目で見る。知覚する、理解する。備えることです。",
    u: "旧約聖書で1311回使用されています。神は見て良しとされました。",
    e: "基本語根"
  },
  "H7225": {
    m: "初め、初穂",
    d: "始まり、開始。最良のもの、初穂です。",
    u: "旧約聖書で51回使用されています。「初めに神は創造された……」",
    e: "רֹאשׁ（ローシュ）から = 頭、始まり"
  },
  "H7257": {
    m: "横たわる、休む",
    d: "横たわる、休む。住む。卵を抱くことです。",
    u: "旧約聖書で30回使用されています。私を休ませてくださいます（詩篇23:2）。",
    e: "基本語根"
  },
  "H7291": {
    m: "追う、追いかける",
    d: "追う、追いかける。迫害する。ぴったりとついて行くことです。",
    u: "旧約聖書で144回使用されています。恵みが私を追ってきます。",
    e: "基本語根"
  },
  "H7307": {
    m: "霊、息、風",
    d: "息、風。神または人の霊。心の傾向です。",
    u: "旧約聖書で378回使用されています。神の霊です。",
    e: "רוּחַ（ルーアハ）から = 吹く"
  },
  "H7462": {
    m: "牧する、飼う、養う",
    d: "群れを牧する。羊飼いである。養い、世話をすることです。",
    u: "旧約聖書で173回使用されています。主は私の羊飼いです。",
    e: "基本語根"
  },
  "H7549": {
    m: "大空、天の丸天井",
    d: "大空、天の丸天井、大空。天です。",
    u: "旧約聖書で17回使用されています。水の間の大空です。",
    e: "רָקַע（ラーカ）から = 広げる、打つ"
  },
  "H7626": {
    m: "杖、部族",
    d: "杖、むち。部族、家族の枝です。",
    u: "旧約聖書で190回使用されています。あなたの杖とあなたのつえです。",
    e: "שָׁבַט（シャーバト）から = 枝分かれする"
  },
  "H7725": {
    m: "戻る、帰る、回復する",
    d: "戻る、帰る。回復する、新しくする。悔い改めることです。",
    u: "旧約聖書で1058回使用されています。私の魂を生き返らせてくださいます。",
    e: "基本語根"
  },
  "H7979": {
    m: "食卓",
    d: "食事のための食卓。臨在のパンの食卓です。",
    u: "旧約聖書で71回使用されています。整えられた食卓です。",
    e: "שָׁלַח（シャーラハ）から = 送る、広げる"
  },
  "H8064": {
    m: "諸天、天",
    d: "諸天、大空。神の住まい。目に見える空です。",
    u: "旧約聖書で420回使用されています。天と地です。",
    e: "שָׁמַיִם（シャマイム）= 高所 の双数形"
  },
  "H8414": {
    m: "形なく、空虚、混沌",
    d: "荒野、荒廃。混沌、空虚、無です。",
    u: "旧約聖書で20回使用されています。地は形なく、空虚でした。",
    e: "תָּהָה（ターハー）から = さまよう"
  }
};

export default strongTranslationsJA;
